import React from 'react';
import ReactDOM from 'react-dom/client';
// data-bunker-ui:start — generado por setup-project.mjs (no editar a mano; re-corre el setup)
import '@fontsource/oswald/400.css';
import '@fontsource/oswald/500.css';
import '@fontsource/oswald/600.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/500.css';
import '@fontsource/open-sans/600.css';
import '@fontsource/open-sans/700.css';
import './ds/db.css'; // Tailwind 3: ANTES del CSS global del proyecto
import { registerDataBunkerThemes } from './ds/tokens/echarts-theme';
import { DbThemeProvider } from './ds/theme/ThemeProvider';
// data-bunker-ui:end
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import config from "./aws-exports"
import { installAuthFetch } from './utils/authFetch';

Amplify.configure(config)
installAuthFetch()

registerDataBunkerThemes(); // temas ECharts databunker-light / databunker-dark

const root = ReactDOM.createRoot(document.getElementById('root'));

// Dos plataformas, un solo código: el build con REACT_APP_UI=nueva es la plataforma nueva (todo en
// Glass & Depth, src/nueva/); sin la variable es la de siempre. La condición se resuelve al compilar y
// webpack descarta la otra rama: el build de siempre no trae nada de src/nueva y el nuevo no trae el CSS
// global ni los módulos de la de siempre (por eso index.css, leaflet y App van aquí y no arriba).
if (process.env.REACT_APP_UI === 'nueva') {
  const { default: AppNueva } = require('./nueva/AppNueva');
  root.render(
    <React.StrictMode>
      <AppNueva />
    </React.StrictMode>
  );
} else {
  require('./index.css');
  require('leaflet/dist/leaflet.css');
  const { default: App } = require('./App');
  root.render(
    <React.StrictMode>
      <DbThemeProvider scope="root" defaultTheme="light">
        <App />
      </DbThemeProvider>
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
